import { render, staticRenderFns } from "./version.vue?vue&type=template&id=686d71b1&scoped=true&"
import script from "./version.vue?vue&type=script&lang=ts&"
export * from "./version.vue?vue&type=script&lang=ts&"
import style0 from "./version.vue?vue&type=style&index=0&id=686d71b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686d71b1",
  null
  
)

export default component.exports